import Select from '@trilogy-ds/react/lib/components/select/Select';
/**
 * Select Component
 * @param id {string} Select id
 * @param name {string} Select name
 * @param selected {string} Selected value
 * @param children {React.ReactNode} Children for Select
 * @param label {string} label for select
 * @param iconName {IconName} icon for left of selector
 * @param onChange {Function} onChange Event
 * @param disabled {boolean} disable Select
 * @param multiple {boolean} select multiple options
 * @param nullable {boolean} Unselect Select Option Item
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param native {boolean} Display native-old select web
 * @param className {string} Additional CSS Classes
 * @param accessibilityLabel {string} Accessibility label
 * @param onFocus {Function} OnFocus Input Event
 * @param onBlur {Function} onBlur Input Event
 */
export default Select;
//# sourceMappingURL=Select.js.map